import { LocalizableProvider } from '@contexts/LocalizableContext'
import { InitialConfig as SBAsyncSelectInitialConfig } from '@supplement-bacon/react-async-select'
import { SBModel } from '@supplement-bacon/react-toolkit/models'
import {
  SBRM,
  SBRMAction,
  InitialConfig as SBRMInitialConfig,
} from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { permissionFromEntityAndAction } from '@utils/permissions'
import { App } from 'antd'
import { PropsWithChildren } from 'react'
import { DEFAULT_ERROR, DEFAULT_SUCCESS } from '../App'
import { HeaderLangSelector } from './localizable/HeaderLangSelector'
import { useHasAccess } from './HasAccess'

interface Props {
  config: SBRMInitialConfig['entities'] &
    SBAsyncSelectInitialConfig<SBModel>['entities']
}

const AuthDependantProviders = ({
  config,
  children,
}: PropsWithChildren<Props>) => {
  const { message } = App.useApp()
  const { hasAccess } = useHasAccess()

  /**
   * Use as any to avoid type errors
   * SBRM uses generic types to define the entities
   * and we are using strongly typed entities
   * so we need to cast to any
   */

  return (
    <SBRM
      config={{
        acl: {
          hasAccess: (permissions: any) => hasAccess(permissions),
          permissionFromEntityAndAction: (entity: Entity, action: SBRMAction) =>
            permissionFromEntityAndAction(entity, action),
        },
        entities: config,
      }}
      fireSuccess={() => message.success(DEFAULT_SUCCESS)}
      fireError={(e) => {
        message.error(DEFAULT_ERROR)
      }}
      headerExtra={<HeaderLangSelector />}
      formWrapper={(node) => (
        <LocalizableProvider headerSelector>{node}</LocalizableProvider>
      )}
    >
      {children}
    </SBRM>
  )
}

export default AuthDependantProviders
